import { BaseEntity } from '@models';
import { NumberUtils } from '@utils';

export class CarListBand extends BaseEntity {
	label: string;
	minBudget: number;
	maxBudget: number;
	organizationId: string;

	constructor(other?: Partial<CarListBand>) {
		super();
		other && Object.assign(this, other);
	}

	get budgetRange() {
		return `${[
			NumberUtils.formatAsPrice(this.minBudget, { defaultValue: '', pureDefault: true }),
			NumberUtils.formatAsPrice(this.maxBudget, { defaultValue: '', pureDefault: true })
		].join(' - ')}`;
	}
}
